import React from "react";
import { getHyreferralCampaignsOverview } from "relay/campaigns";
import OverviewDetails from "./Components/overviewDetails"
import { withStyles } from '@material-ui/core';
import moment from "moment"

const styles = () => ({
  header: {
    fontSize: "24px",
    lineHeight: "36px",
    fontFamily: "Open Sans",
    color: "#000000",
    marginBottom: 16
  },
  overviewContainer: {
    margin: "24px 0px"
  }
})

const statsArray = [
  {
    key: "propertiesCount",
    label: "# Properties"
  },
  {
    key: "campaignsCount",
    label: "# Campaigns"
  },
  {
    key: "enrollmentsCount",
    label: "# Residents",
    tooltipText: "# of Residents Enrolled in the referrer campaign"
  },
  {
    key: "referredCount",
    label: "# Friends",
    tooltipText: "# of Referred friends who submitted a guest card or scheduled a tour"
  },
  {
    key: "leasedCount",
    label: "# Leased",
    tooltipText: "# of Referred friends who leased"
  },
]


const campaignSelect = [
  {
    key: "residentsCount",
    label: "# Residents",
    tooltipText: "# of Residents Enrolled in the referrer campaign"
  },
  {
    key: "friendsCount",
    label: "# Friends",
    tooltipText: "# of Referred friends who submitted a guest card or scheduled a tour"
  },
  {
    key: "leasedCount",
    label: "# Leased",
    tooltipText: "# of Referred friends who leased"
  },
  {
    key: "active",
    label: "Campaign Status",
  },
  {
    key: "createdAt",
    label: "Date Created",
  }
]

const Overview = ({ classes, monthRange, orgId, subMenu, headerText, defaultSelectedCampaign, chartData }) => {
  const [loading, setLoading] = React.useState(true);
  const [topChart, setTopChart] = React.useState();

  React.useEffect(() => {
    if (subMenu == 0) {
      initData(monthRange, orgId)
    } else {
      initCampaignData();
    }
  }, [monthRange, orgId, defaultSelectedCampaign])

  const initCampaignData = () => {
    if (defaultSelectedCampaign) {
      let array = [];
      for (let i = 0; i < campaignSelect.length; i++) {
        let count;
        if (campaignSelect[i].key == "active") {
          count = (defaultSelectedCampaign.active || defaultSelectedCampaign.campaignActive) ? "Active" : "Inactive"
        } else if (campaignSelect[i].key == "createdAt") {
          count = moment(defaultSelectedCampaign[campaignSelect[i].key]).format("DD/MM/YYYY")
        } else {
          count = defaultSelectedCampaign[campaignSelect[i].key]
        }
        array.push({
          count: count,
          label: campaignSelect[i].label,
          tooltipText: campaignSelect[i].tooltipText
        })
      }
      setTopChart(array);
      setLoading(false);
    }
  }


  const initData = async () => {
    setLoading(true);
    let array = [];
    for (let i = 0; i < statsArray.length; i++) {
      array.push({
        count: chartData[statsArray[i].key],
        label: statsArray[i].label,
        tooltipText: statsArray[i].tooltipText
      })
    }
    setTopChart(array);
    setLoading(false);
  }

  // const initData = async (date, orgId) => {
  //   setLoading(true);
  //   try {
  //     let response = await getHyreferralCampaignsOverview(orgId, "", date.startAt, date.endAt);
  //     if (response.hyreferralCampaignsOverview) {
  //       let array = [];
  //       for (let i = 0; i < statsArray.length; i++) {
  //         array.push({
  //           count: response.hyreferralCampaignsOverview[statsArray[i].key],
  //           label: statsArray[i].label,
  //           tooltipText: statsArray[i].tooltipText
  //         })
  //       }
  //       setTopChart(array);
  //       setLoading(false);
  //     }
  //   } catch (err) {
  //     console.log("Err:", err)
  //   }
  // }
  if (loading) {
    return <div></div>
  }

  return (
    <div className={classes.overviewContainer}>
      <div className={classes.header}>{headerText}</div>
      <OverviewDetails
        topChart={topChart}
      />
    </div>

  )
}

export default withStyles(styles)(Overview)